export default "__VITE_ASSET__CG1s1ztH__"